// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4l-2";
export var blackBorderOnHover = "_4l-7";
export var cell = "_4l-6";
export var cellContainer = "_4l-3";
export var checked = "_4l-8";
export var disabled = "_4l-5";
export var featuredIconCellContainer = "_4l-9";
export var featuredIconTextContainer = "_4l-b";
export var featuredIconWrapper = "_4l-a";
export var noBorder = "_4l-c";
export var orangeSelectedRow = "_ck-3";
export var overflowableText = "_4l-0";
export var overflowableTextContainer = "_4l-1";
export var row = "_4p-0";
export var rowCheckboxCell = "_4l-4";
export var selectableTable = "_ck-2";